import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrg } from '../../lib/OrgProvider';
import { captureEvent } from '../../lib/telemetry/posthog/frontend';

/** Continue straight into creation; trial details remain available in billing and the sidebar. */
export const TrialActivatedStep = () => {
  const { acknowledgeTrial } = useOrg();
  const navigate = useNavigate();
  const completed = useRef(false);
  useEffect(() => {
    if (completed.current) return;
    completed.current = true;
    captureEvent('onboarding.trial_acknowledged');
    void navigate('/admin/setup', { replace: true });
    acknowledgeTrial();
  }, [acknowledgeTrial, navigate]);
  return null;
};
